// extracted by mini-css-extract-plugin
export default {"input-container":"style_input-container__H+0Ul","search-icon":"style_search-icon__GJXUt"};